import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PLANS, brl } from "@/lib/api";
import { Reveal, Eyebrow } from "./Reveal";

const PlanCard = ({ plan, onBook, i }) => (
  <Reveal delay={i * 0.08} className="h-full">
    <motion.button whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 22 }}
      data-testid={`plan-card-${plan.id}`} onClick={() => onBook(plan.id)}
      className="group relative flex h-full w-full flex-col justify-between overflow-hidden rounded-2xl border border-white/10 bg-[#1A0A2E]/70 p-7 text-left transition-[border-color,box-shadow] duration-500 hover:border-[#CBA365]/60 hover:shadow-[0_0_60px_-10px_rgba(203,163,101,0.35)] md:p-8">
      <div className="flex items-start justify-between">
        <span className="font-display text-sm uppercase tracking-[0.35em] text-[var(--gold)]">{plan.arcana} · {plan.name}</span>
        <ArrowUpRight className="h-5 w-5 text-white/50 transition-[transform,color] duration-500 group-hover:rotate-45 group-hover:text-[var(--gold)]" />
      </div>
      <div className="mt-10">
        <h3 className="font-display text-3xl text-[#F5F2EB] md:text-4xl">{plan.label}</h3>
        <p className="mt-2 text-sm text-white/65">{plan.note}</p>
        <p data-testid={`plan-price-${plan.id}`} className="font-display mt-6 text-5xl tracking-tight gold-text">{brl(plan.price)}</p>
      </div>
    </motion.button>
  </Reveal>
);

const Featured = ({ plan, onBook }) => (
  <Reveal className="h-full">
    <motion.button whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 22 }}
      data-testid={`plan-card-${plan.id}`} onClick={() => onBook(plan.id)}
      className="group relative flex h-full min-h-[520px] w-full flex-col justify-end overflow-hidden rounded-2xl border border-[#CBA365]/40 text-left">
      <img src="/img/reader.jpg" alt="Mãos sobre cartas de tarot e velas" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#080312] via-[#080312]/70 to-[#080312]/10" />
      <span className="absolute left-6 top-6 rounded-full border border-[#CBA365]/60 bg-[#080312]/60 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-[var(--gold)] backdrop-blur-md">Experiência completa</span>
      <div className="relative p-8 md:p-10">
        <span className="font-display text-sm uppercase tracking-[0.35em] text-[var(--gold)]">{plan.arcana} · {plan.name}</span>
        <h3 className="font-display mt-3 text-5xl text-[#F5F2EB] md:text-6xl">{plan.label}</h3>
        <p className="mt-3 max-w-sm text-sm text-white/80 md:text-base">{plan.note}</p>
        <div className="mt-8 flex items-end justify-between gap-4">
          <p data-testid={`plan-price-${plan.id}`} className="font-display text-6xl tracking-tight gold-text md:text-7xl">{brl(plan.price)}</p>
          <span className="rounded-full bg-[var(--gold)] px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#080312] transition-colors duration-300 group-hover:bg-[var(--gold-hi)]">Agendar</span>
        </div>
      </div>
    </motion.button>
  </Reveal>
);

export const Pricing = ({ onBook }) => {
  const featured = PLANS.find((p) => p.id === "meia-hora");
  const rest = PLANS.filter((p) => p.id !== "meia-hora");
  return (
    <section id="leituras" data-testid="pricing-section" className="relative mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow>Leituras & valores</Eyebrow>
          <h2 className="font-display mt-6 text-5xl leading-[0.95] tracking-tight text-[#F5F2EB] md:text-7xl">
            Escolha o seu <em className="gold-text">arcano.</em>
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-white/70 md:text-base">Pagamento único via Pix. Sem cadastro, sem mensalidade. A leitura acontece no WhatsApp.</p>
      </Reveal>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-12 md:gap-6">
        <div className="md:col-span-7 md:row-span-2"><Featured plan={featured} onBook={onBook} /></div>
        <div className="md:col-span-5"><PlanCard plan={rest[0]} onBook={onBook} i={0} /></div>
        <div className="md:col-span-5"><PlanCard plan={rest[1]} onBook={onBook} i={1} /></div>
        <div className="md:col-span-12"><PlanCard plan={rest[2]} onBook={onBook} i={2} /></div>
      </div>
    </section>
  );
};
